<template>
  <div :class="{'animate-blink': isRecording}">
    <v-btn
      v-if="!isRecording"
      @click="record"
      icon
      flat
      small>
      <v-icon>mic</v-icon>
    </v-btn>
    <v-btn
      v-else
      color="red lighten-1"
      @click="stop"
      icon
      flat
      small>
      <v-icon>stop</v-icon>
    </v-btn>

    <span v-show="isRecording">{{recordingTime | duration}}</span>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
  data() {
    return {
      isRecording: false,
      recordingTime: 0
    };
  },

  props: {
    mimeType: {
      type: String,
      default: 'audio/webm'
    },

    bitsPerSecond: {
      type: Number,
      default: 128000
    }
  },

  computed: {
    ...mapState('chat', {
      currentChatId: state => state.currentChat.id
    })
  },

  watch: {
    currentChatId() {
      this.stop();
    }
  },

  filters: {
    duration(totalSeconds) {
      let minutes = Math.floor(totalSeconds / 60);
      let seconds = totalSeconds % 60;
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      return `${minutes}:${seconds}`;
    }
  },

  beforeDestroy() {
    this.stop();
  },

  methods: {
    ...mapActions('alert', {
      addErrorAlert: 'addError'
    }),

    async enableMic() {
      let stream;
      try {
        stream = await navigator.mediaDevices.getUserMedia({audio: true});
      } catch (e) {
        log.error('recordAudio error', e);
        let errMsg = '無法開啟麥克風: ' + e.message;
        this.addErrorAlert(errMsg);
      }

      return stream;
    },

    async record() {
      let stream = await this.enableMic();
      if (!stream) {
        return;
      }

      this._recordChatId = this.currentChatId;
      clearInterval(this._interval);

      this._chunks = [];
      this.recordingTime = 0;

      this._recorder = new MediaRecorder(stream, {
        mimeType: this.mimeType,
        audioBitsPerSecond: this.bitsPerSecond
      });

      this._recorder.addEventListener('dataavailable', e => {
        this._chunks.push(e.data);
      });
      this._recorder.addEventListener('stop', this.onStop.bind(this));
      this._recorder.start();

      this.isRecording = true;
      this._interval = setInterval(() => this.recordingTime++, 1000);

      this.$emit('start');
    },

    stop() {
      if (this._recorder && this._recorder.state !== 'inactive') {
        this._recorder.stop();
        this._recorder.stream.getTracks().forEach(track => track.stop());
      }
      clearInterval(this._interval);
    },

    onStop(event) {
      if (this._recordChatId === this.currentChatId) {
        let blob = new Blob(this._chunks, {type: this.mimeType});
        this.$emit('stop', blob);
      }
      this._chunks = [];
      this.isRecording = false;
    }
  }
};
</script>

<style lang="stylus" scoped>
</style>
